import React from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { LocalizedButton as Button } from './i18n/LocalizedMui';
import Typography from './i18n/LocalizedTypography';

type PremiumTrialPopupProps = {
  open: boolean;
  featureName: string;
  used: number;
  total: number;
  remaining: number;
  loading: boolean;
  onCancel: () => void;
  onContinue?: (() => void | Promise<void>) | null;
};

const PremiumTrialPopup: React.FC<PremiumTrialPopupProps> = ({
  open,
  featureName,
  loading,
  onCancel,
  onContinue
}) => {
  return (
    <Dialog open={open} onClose={loading ? undefined : onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Start Your Studio Trial</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 1.5 }}>
          <strong>{featureName}</strong> is included during your 3-day Kundlistar Studio trial.
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          Use the full studio during trial. After the trial ends, upgrade to Premium to keep full access.
        </Typography>
        <Box sx={{ bgcolor: "var(--app-surface-neutral, #f3f7f4)", borderRadius: 2, p: 2, my: 2 }}>
          <Typography>Trial period: <strong>3 days</strong></Typography>
          <Typography>Feature: <strong>{featureName}</strong></Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          Continue to use this studio feature now.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0 }}>
        <Button onClick={onCancel} disabled={loading}>Cancel</Button>
        <Button variant="contained" onClick={() => onContinue?.()} disabled={loading || !onContinue}>
          {loading ? 'Opening...' : 'Continue'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PremiumTrialPopup;
